<template>
    <div class="dashboard-filters">
        <div class="dashboard-filters__item">
          <Select2
                :options="['Partner 1','Partner 2']"
                :settings="{
                    placeholder: 'Service'
                }"
                @change="filter"
            />
        </div>

        <div class="dashboard-filters__item">
          <Select2
                :options="['Partner 1','Partner 2']"
                :settings="{
                    placeholder: 'Month'
                }"
                @change="filter"
            />
        </div>

        <div class="dashboard-filters__item">
          <Select2
                :options="['Partner 1','Partner 2']"
                :settings="{
                    placeholder: 'Partners'
                }"
                @change="filter"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'dashboard-filters',
    methods: {
        filter() {},
    },
}
</script>

<style lang="scss" scoped>
.dashboard-filters {
    width: 100%;
    height: 45px;
    display: flex;

    &__item {
        width: 140px;
        margin-right: 55px;
    }
}
</style>
